export const convertMapImageUrl = (imageUrl) => {
	if (!imageUrl) {
		return null
	}
	const width = '1000'
	const height = '500'
	return imageUrl.replace(/w=\d+&h=\d+/, `w=${width}&h=${height}`)?.replace(/\/(\d+)x(\d+)\//, `/${width}x${height}/`)
}
